<template>
  <v-layout row wrap pa-0>
    <v-layout row style="position:relative">
      <h2 class="mb-1 pr-3" style="padding-right:240px !important;">Tasks</h2>
    </v-layout>
    <v-flex xs12 pt-2>
      <CaseTasklist
        v-for="(tasklist, index) in tasklists"
        :key="index"
        :tasklist="tasklist">
      </CaseTasklist>
      <v-btn
        v-show="addTasklistButton"
        v-on:click="addTasklistForm = true; addTasklistButton = false"
        class="ml-0"
        color="secondary"
        style="float:left;"
      >Add a tasklist</v-btn>
      <form v-show="addTasklistForm" @submit="createTasklist()">
        <v-layout wrap row class="pa-4 mt-0 white-bg rounded-3" >
          <v-flex xs12 sm6>
          <h3 class="pb-3">Add a new tasklist</h3>
            <v-text-field v-model="newTasklistName" label="New tasklist name" box></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-btn class="ml-0 mt-0" color="success" @click="createTasklist()">Save Tasklist</v-btn>
            <v-btn
            class="mt-0"
              color="error"
              v-on:click="clearNewTasklist()"
            >Cancel</v-btn>
          </v-flex>
        </v-layout>
      </form>
    </v-flex>
  </v-layout>
</template>

<script>
import CaseTasklist from "@/components/cases/case-edit/CaseTasklist"
import Helpers from "@/helpers.js"
import { mapState } from 'vuex'

export default {
  name: "CaseTasklistContainer",
  props: {
    theCase: { type: Object, required: true }
  },
  computed: {
    ...mapState({
      caseType: state => state.buckets.current.caseType,
      caseId: state => state.cbroute.params.case_id
    }),
    tasklists() {
      if (this.theCase && this.theCase.tasklists && Array.isArray(this.theCase.tasklists)) {
        Helpers.orderItemsByPosition(this.theCase.tasklists)
        return this.theCase.tasklists
      } else {
        return []
      }
    },
    dayOptions() {
      const days = []
      for (let i = 0; i < 101; i++) { days.push((i)) }
      return days
    },
    hourOptions() {
      const hours = []
      for (let i = 0; i < 25; i++) { hours.push((i)) }
      return hours
    },
    minuteOptions() {
      const minutes = []
      for (let i = 0; i < 61; i++) { minutes.push((i)) }
      return minutes
    }
  },
  data: () => ({
    on: false,
    items: ["Foo", "Bar", "Fizz", "Buzz"],
    dialogRunTask: false,
    dialogRunTaskParameters: false,
    dialogLog: false,
    taskComplete: false,
    taskComplete2: false,
    taskComplete3: false,
    taskComplete4: false,
    taskComplete5: false,
    taskComplete6: false,
    dialogTasklistDelete: false,
    dialogTasklistDelete2: false,
    addTaskButton: true,
    addTaskForm: false,
    addTasklistButton: true,
    addTasklistForm: false,
    tasklistTitle: true,
    tasklistTitleEdit: false,
    taskMenu: false,
    newTasklistName: "",
    selectedTeam: "",
    selectedUser: "",
    userSwitch: "",
    teamsItems: [
      { id: 20, displayName: "Management" },
      { id: 30, displayName: "Customer Service" }
    ],
    userItems: [
      {
        name: "Paul McGlynn",
        avatar: "https://randomuser.me/api/portraits/women/17.jpg"
      },
      {
        name: "Jonathan Bean",
        avatar: "",
        initials: "JB"
      },
      {
        name: "Andrew Brown",
        avatar: "https://randomuser.me/api/portraits/women/11.jpg",
        group: "chip-individual"
      },
      {
        name: "James Brown",
        avatar: "https://randomuser.me/api/portraits/women/1.jpg"
      },
      {
        name: "John Doe",
        avatar: "https://randomuser.me/api/portraits/women/17.jpg"
      },
      {
        name: "Jane Doe",
        avatar: "",
        initials: "JB"
      }
    ],
    scheduleValue: "",
    scheduleItems: ["At", "By", "Recurring"],
    scheduleHrsValue: "00",
    scheduleMinsValue: "00",
    scheduleDateValue: "1st",
    scheduleMonthValue: "January",
    everyValue: "Minute",
    everyItems: ["Minute", "Hour", "Day", "Week", "Month", "Year"],
    minsValue: "00",
    dayMinsValue: "00",
    dayHourItems: [
      "00", "01", "02", "03", "04", "05", "06", "07",
      "08", "09", "10", "11", "12", "13", "14", "15",
      "16", "17", "18", "19", "20", "21", "22", "23"
    ],
    dayHourValue: "00",

    weekMinsValue: "00",
    weekHourItems: [
      "00", "01", "02", "03", "04", "05", "06", "07",
      "08", "09", "10", "11", "12", "13", "14", "15",
      "16", "17", "18", "19", "20", "21", "22", "23"
    ],
    weekHourValue: "00",
    weekDayValue: "Sunday",
    weekDayItems: [
      "Sunday", "Monday", "Tuesday", "Wednesday",
      "Thursday", "Friday", "Saturday"
    ],
    monthDateValue: "1st",
    monthDateItems: [
      "1st", "2nd", "3rd", "4th", "5th", "6th", "7th", "6th", "8th", "9th", "10th",
      "11th", "12th", "13th", "14th", "15th", "16th", "17th", "18th", "19th", "20th",
      "21st", "22nd", "23rd", "24th", "25th", "26th", "27th", "28th", "29th", "30th",
      "31st"
    ],
    monthMinsValue: "00",
    monthHourItems: [
      "00", "01", "02", "03", "04", "05", "06", "07",
      "08", "09", "10", "11", "12", "13", "14", "15",
      "16", "17", "18", "19", "20", "21", "22", "23"
    ],
    monthHourValue: "00",
    yearHourValue: "00",
    yearMinsValue: "00",
    yearHourItems: [
      "00", "01", "02", "03", "04", "05", "06", "07",
      "08", "09", "10", "11", "12", "13", "14", "15",
      "16", "17", "18", "19", "20", "21", "22", "23"
    ],
    yearDateValue: "1st",
    yearDateItems: [
      "1st", "2nd", "3rd", "4th", "5th", "6th", "7th", "8th", "9th", "10th",
      "11th", "12th", "13th", "14th", "15th", "16th", "17th", "18th", "19th", "20th",
      "21st", "22nd", "23rd", "24th", "25th", "26th", "27th", "28th", "29th", "30th", "31st"
    ],
    yearMonthValue: "January",
    yearMonthItems: [
      "January", "February", "March",
      "April", "May", "June",
      "July", "August", "September",
      "October", "November", "December"
    ],
    yearYearItems: ["2019", "2020", "2021", "2022", "2023", "2024"],
    scheduleYearValue: "2019"
  }),
  components: { CaseTasklist },
  methods: {
    async createTasklist() {
      await this.$store.dispatch("createCaseTasklist", {
        caseId: parseInt(this.caseId),
        name: this.newTasklistName,
        position: this.tasklists.length
      })
      this.clearNewTasklist()
    },
    clearNewTasklist() {
      this.addTasklistForm = false
      this.addTasklistButton = true
      this.newTasklistName = ""
    },
    remove(item) {
      const index = this.selectedUser.indexOf(item.name)
      if (index >= 0) this.selectedUser.splice(index, 1)
    }
  }
}
</script>

<style>
.accordion-parent .v-expansion-panel__header__icon {
  position: absolute;
  right: 49px;
  top: 21px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  width: 28px;
  height: 28px;
  vertical-align: top;
  font-family: Roboto, sans-serif;
  left: initial !important;
}

.accordion-parent.no-remove .v-expansion-panel__header__icon {
  right: 22px;
}

.accordion-parent .with-remove .v-expansion-panel__header__icon {
  right:49px;
}

.accordion-parent .v-expansion-panel__header__icon:hover {
  background: rgba(0, 0, 0, 0.2);
}

.accordion-parent .accordion-child .v-expansion-panel__header {
  padding: 4px 24px !important;
  min-height: 20px;
  font-family: Roboto, sans-serif;
}

.accordion-parent .v-expansion-panel__header h3 {
  font-family: Roboto, sans-serif;
}

.accordion-parent .accordion-child .v-expansion-panel__header__icon {
  top: 7px;
}

.white-box-field .v-input__slot {
  background: white !important;
}

.accordion-parent .v-expansion-panel__header__icon .v-icon {
  vertical-align: middle;
  text-align: center;
  padding: 0 !important;
  margin: 2px 0 0 2px !important;
  transform-origin: center;
  left: initial !important;
}

.tasklist-task .v-expansion-panel__header__icon {
  display: none !important;
}

.tasklist-task .v-expansion-panel__header h3 {
  position: relative;
}

.accordion-parent
  .accordion-child
  .v-expansion-panel.tasklist-task
  .v-expansion-panel__header {
  padding-left: 0px !important;
  font-family: Roboto, sans-serif;
}

.accordion-child .v-expansion-panel__header {
  padding: 0px !important;
}

.accordion-parent
  .accordion-child
  .v-expansion-panel.tasklist-task.case
  .v-expansion-panel__header {
  padding: 0px !important;
}

.tasklist-task .v-expansion-panel__header h3 {
  float: left;
  padding-right: 24px;
}

.tasklist-task .v-expansion-panel__header h3:after {
  content: "...";
  position: absolute;
  top: 0px;
  right: 10px;
}

.tasklist-task .v-expansion-panel__header:hover h3:after {
  letter-spacing: 3px;
  right: 1px;
}

.overdue {
  color: #db444d;
  position: relative;
}

.imminent {
  color: #f19916;
  position: relative;
}

code:before {
  display: none !important;
}

.v-text-field,
.v-label,
.v-btn {
  font-family: Roboto, sans-serif !important;
}
</style>
